export default __webpack_public_path__ + "static/media/postermodalimg.d4b6b832.jpg";